import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import dateFormat from 'dateformat';
import { FaRegTrashAlt } from 'react-icons/fa';

import styles from './styles.scss';

export class CardReviewsItem extends React.Component {
    static propTypes = {
        review: PropTypes.object.isRequired,
        onDelete: PropTypes.func,
    };

    render() {
        const { review, onDelete } = this.props;

        return (
            <li className={styles.root}>
                <div className={styles.avatarContainer}>
                    <img src={review.author.avatarUrl} alt={review.author.name} />
                </div>
                <div className={styles.commentContent}>
                    <span className={styles.name}>{review.author.name}</span>
                    <span className={classNames(styles.date, review.recommend ? styles.green : styles.red)}>
                        {dateFormat(review.createdAt, 'dd.mm.yyyy HH:MM')}
                    </span>
                    <p className={styles.comment}>{review.message}</p>
                    {onDelete && (
                        <span className={styles.deleteButton} onClick={onDelete}>
                            <FaRegTrashAlt size={16} color="#8E8E93" />
                        </span>
                    )}
                </div>
            </li>
        );
    }
}
